import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import Notification from '../../handlers/Notification';

export const handleNewMessages = (payload, action) => {
    return (dispatch, getState) => {
        const { session, chatMembers, chats, activeInbox, json_lang } = getState();

        // console.log("payload ======> ",payload);
        // console.log("session ======> ",session);
        // console.log("chatMembers ======> ",chatMembers);
        // console.log("chats ======> ",chats);
        // console.log("action ======> ",action);

        const sameChatroom = chats.data.find(chat => chat.room_id === payload.room_id);
        const chatMemberIndex = chatMembers.data.findIndex(chat => chat.room_id === payload.room_id);
    
        if(chatMembers.data.length === 0 && action === "new"){
            if(chats.data.length === 0) {
                localStorage.setItem(
                    "hasUnreadMessages",
                    JSON.stringify(true)
                );
                window.dispatchEvent(new CustomEvent('hasUnreadMessages', {
                    detail: {
                        value: true
                    }
                }));
            } else {
                 if(!sameChatroom){
                    localStorage.setItem(
                        "hasUnreadMessages",
                        JSON.stringify(true)
                    );
                    window.dispatchEvent(new CustomEvent('hasUnreadMessages', {
                        detail: {
                            value: true
                        }
                    }));
                 }
            }
        } else if(activeInbox) {
            if(chatMemberIndex !== -1){
                const prevChatMemberData = [...chatMembers.data];
                const updatedChatMember = prevChatMemberData.splice(chatMemberIndex, 1)[0];

                updatedChatMember.room.last_message = {...payload};

                prevChatMemberData.unshift(updatedChatMember);

                dispatch({
                    type: "FETCH_CHAT_MEMBERS",
                    chatMembers: {
                        ...chatMembers,
                        data: [...prevChatMemberData]
                    },
                    activeInbox: true
                });
            } else {
                dispatch({
                    type: "NEW_CHAT_MEMBER",
                    newChatMember: true
                });
            }
        }

        if(chats.data.length > 0){
            if(sameChatroom){
                let prevMessageData = [...chats.data];
                const messageIndex = chats.data.findIndex(chat => chat.id === payload.id);
                if(messageIndex !== -1){
                    prevMessageData[messageIndex] = { ...payload };
                    if(payload.is_read && payload.is_mine){
                        prevMessageData.forEach((chat, index) => {
                            if(chat.is_mine && !chat.is_read){
                                prevMessageData[index].is_delivered = true;
                                prevMessageData[index].is_read = true;
                            }
                        });
                    }
                } else{
                    prevMessageData = [...prevMessageData].concat(payload);
                }
                dispatch({
                    type: "FETCH_CHATS",
                    chats: {
                        ...chats,
                        data: [...prevMessageData]
                    }
                });
            }
        }
        if(!sameChatroom){
            Notification.show({ type: "success", title: json_lang.firebase.new_message, msg: json_lang.firebase.new_message_description, chatData: payload });
        }
    }
}

export const fetchChatMembers = () => {
    return (dispatch, getState) => {
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        const { company } = getState();
        const query = "with=room.lastMessage,chatTarget";
        const url_host = `${URL + company.id}/chat-members?` + query + `&limit=100&sort_by=updated_at,desc`;
        return axios.get(url_host).then((res) => {
            dispatch({
                type: "FETCH_CHAT_MEMBERS",
                chatMembers: res.data,
                activeInbox: true
             });
            dispatch({
                type: "NEW_CHAT_MEMBER",
                newChatMember: false
             });
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING" });
            let message = err.data.description;
            let type = "error";
            if(err.data.status_code === 404){
                return;
            }
            Notification.show({
                type: type,
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: message
            });
        });
    }
}

export const fetchChat = (accountId, limit = 100) => {
    return (dispatch,getState) => {
        const { company } = getState();
        let url_host = `${URL+company.id}/accounts/${accountId}/chat-messages?sort_by=id,desc&limit=${limit}`
        return axios.get(url_host)
        .then((res) => {
            dispatch({
                type: 'FETCH_CHATS',
                chats: {
                    ...res.data,
                    data: [
                        ...res.data.data.sort((a,b) => a.id - b.id)
                    ]
                },
            });
        }).catch((err) => {
            let message = err.data.description;
            let type = "error";
            if(err.data.status_code === 404){
                return;
            }
            Notification.show({
                type: type,
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: message
            });
        });
    }
}

export const postMessage = (accountId, message, initialData, type = "text") => {
    return (dispatch,getState) => {
        const { company, chats } = getState();
        let data;
        if(type === "text"){
            data = {
                message: message,
                type: type
            }
        }else{
            data = new FormData();
            data.append("image", message);
            data.append("type", type);
        }
        let url_host = `${URL+company.id}/accounts/${accountId}/chat-messages`;
        return axios.post(url_host, data)
        .then( (res) => {
            if(initialData){
                const newChatData = chats.data;
                const index = newChatData.findIndex(chat => chat.id === initialData.id);
                if(index !== -1){
                    newChatData[index] = {
                        ...res.data
                    }
                    dispatch({
                        type: "FETCH_CHATS",
                        chats: {
                            ...chats,
                            data: newChatData
                        }
                    });
                } else {
                    dispatch({
                        type: 'FETCH_CHATS',
                        chats: {
                            ...chats,
                            data: [...chats.data, res.data]
                        },
                    });
                }
            } else {
                dispatch({
                    type: 'FETCH_CHATS',
                    chats: {
                        ...chats,
                        data: [...chats.data, res.data]
                    },
                });
            }
        }).catch((err) => {
            if(initialData){
                const newChatData = chats.data;
                const index = newChatData.findIndex(chat => chat.id === initialData.id);
                if(index !== -1){
                    newChatData[index] = {
                        ...initialData,
                        is_sending: false,
                        sending_error: true
                    }
                    dispatch({
                        type: "FETCH_CHATS",
                        chats: {
                            ...chats,
                            data: newChatData
                        }
                    });
                } else {
                    dispatch({
                        type: 'FETCH_CHATS',
                        chats: {
                            ...chats,
                            data: [...chats.data, {
                                ...initialData,
                                is_sending: false,
                                sending_error: true
                            }]
                        },
                    });
                }
            } else {
                let message = err.data && err.data.description;
                let type = "error";
                if(err.data && err.data.status_code === 404){
                    message = "Chat no encontrado.";
                    type = "warning";
                }
                Notification.show({
                    type: type,
                    title:`Error ${err && err.data && err.data.error_code}`,
                    msg: message
                });
            }
        });
    }
}

export const messageActions = (messageId, action) => {
    return (dispatch, getState) => {
        const { company, chats } = getState();
        let url_host = `${URL+company.id}/chat-messages/${messageId}/set-${action}`;
        return axios.post(url_host)
        .then(() => {
            let prevMessageData = [...chats.data];
            const messageIndex = chats.data.findIndex(chat => chat.id === messageId);
            if(messageIndex !== -1){
                if(action === "read"){
                    prevMessageData[messageIndex].is_read = true;
                    prevMessageData[messageIndex].is_mine = false;
                } else {
                    prevMessageData[messageIndex].is_delivered = true;
                }
            }
            dispatch({
                type: 'FETCH_CHATS',
                chats: {
                    ...chats,
                    data: [...prevMessageData]
                },
            });
        }).catch((err) => {
            let message = err.data && err.data.description;
            let type = "error";
            if(err.data && err.data.status_code === 404){
                message = "Chat no encontrado.";
                type = "warning";
            }
            Notification.show({
                type: type,
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: message
            });
        });
    }
}

export const findUser = (accountId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        const { company } = getState();
        let url_host = `${URL+company.id}/accounts/${accountId}`;
        return axios.get(url_host)
        .then((res) => {
            const userType = res.data.type_name;
            dispatch({
                type: 'FETCH_CHAT_USER',
                chatUser: res.data[userType]
            });
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING" });
            let message = err.data && err.data.description;
            let type = "error";
            if(err.data && err.data.status_code === 404){
                message = "Usuario no encontrado.";
                type = "warning";
            }
            Notification.show({
                type: type,
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: message
            });
        });
    }
}

export const clearChats = (onlyChat) => {
    return(dispatch) => {
        const pagination = {
            current_page: 1,
            data: [],
            per_page: 100,
            total: 1,
            limit: 100
        }
        if(onlyChat){
            dispatch({
                type: "FETCH_CHATS",
                chats:{ ...pagination }
            });
            dispatch({
                type: "FETCH_CHAT_USER",
                chatUser: {}
            });
        } else {
            dispatch({
                type: 'CLEAR_CHATS',
                chatUser: {},
                chats: { ...pagination },
                chatMembers: { ...pagination },
                activeInbox: false
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/chatActions.js